import PropTypes from 'ant-design-vue/es/_util/vue-types'

import 'ant-design-vue/es/menu/style'
import Menu from 'ant-design-vue/es/menu'
import 'ant-design-vue/es/icon/style'
import Icon from 'ant-design-vue/es/icon'

const {
  Item: MenuItem,
  SubMenu
} = Menu

export const RouteMenuProps = {
  menus: PropTypes.array,
  theme: PropTypes.string.def('dark'),
  mode: PropTypes.string.def('inline'),
  collapsed: PropTypes.bool.def(false),
  i18nRender: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).def(false)
}

const httpReg = /(http|https|ftp):\/\/([\w.]+\/?)\S*/

const renderMenu = (h, item, i18nRender) => {
  if (item && !item.hidden) {
    const bool = item.children && !item.hideChildrenInMenu
    return bool ? renderSubMenu(h, item, i18nRender) : renderMenuItem(h, item, i18nRender)
  }
  return null
}

const renderSubMenu = (h, item, i18nRender) => {
  return (
    <SubMenu key={item.name} title={(
      <span>
        {renderIcon(h, item.meta.icon)}
        <span>{renderTitle(h, item.meta.title, i18nRender)}</span>
      </span>
    )}>
      {!item.hideChildrenInMenu && item.children.map(cd => renderMenu(h, cd, i18nRender))}
    </SubMenu>
  )
}

const renderMenuItem = (h, item, i18nRender) => {
  const meta = Object.assign({}, item.meta)
  const target = meta.target || null
  const hasRemoteUrl = httpReg.test(item.path)
  const CustomTag = target && 'a' || 'router-link'
  const props = { to: { name: item.name } }
  const attrs = (hasRemoteUrl || target) ? { href: item.path, target: target } : {}
  if (item.children && item.hideChildrenInMenu) {
    // 把有子菜单的 并且 父菜单是要隐藏子菜单的
    // 都给子菜单增加一个 hidden 属性
    // 用来给刷新页面时， selectedKeys 做控制用
    item.children.forEach(cd => {
      cd.meta = Object.assign(cd.meta || {}, { hidden: true })
    })
  }
  return (
    <MenuItem key={item.name}>
      <CustomTag {...{ props, attrs }}>
        {renderIcon(h, meta.icon)}
        {renderTitle(h, meta.title, i18nRender)}
      </CustomTag>
    </MenuItem>
  )
}

const renderIcon = (h, icon) => {
  if (icon === undefined || icon === 'none' || icon === null) {
    return null
  }
  const props = {}
  typeof (icon) === 'object' ? (props.component = icon) : (props.type = icon)
  return <Icon {...{ props }} />
}

// 菜单名称国际化映射
const getMenuLabel = (title, i18nRender) => {
  if (!title) return title
  
  // 菜单名称国际化映射表
  const menuLabelMap = {
    '短剧管理': 'menu.videoManagement',
    '短剧列表': 'menu.videoList',
    '弹幕管理': 'menu.barrageManagement',
    '宣传片管理': 'menu.publicizeManagement',
    '敏感词管理': 'menu.sensitiveWordManagement',
    '短剧分类管理': 'menu.videoCategoryManagement',
    '用户购买剧集列表': 'menu.userBuyVideoList',
    '用户管理': 'menu.userManagement',
    '用户信息': 'menu.userInfo',
    '用户提现': 'menu.userWithdraw',
    '用户反馈': 'menu.userFeedback',
    '用户注销管理': 'menu.userCancelManagement',
    '用户报表': 'menu.userReport',
    '用户权益': 'menu.userRights',
    '兑换码': 'menu.exchangeCode',
    '拉人奖励配置': 'menu.referralRewardConfig',
    '会员购买列表': 'menu.vipPurchaseList',
    '签到配置': 'menu.signConfig',
    '任务奖励管理': 'menu.taskRewardManagement',
    '充值管理': 'menu.rechargeManagement',
    '充值菜单管理': 'menu.rechargeMenuManagement',
    '会员菜单管理': 'menu.vipMenuManagement',
    '资源位配置': 'menu.resourcePositionConfig',
    '网址管理': 'menu.urlManagement',
    '帮助中心': 'menu.helpCenter',
    '引导页': 'menu.guidePage',
    '分销配置': 'menu.distributionConfig',
    '轮播图管理': 'menu.carouselManagement',
    '搜索词管理': 'menu.searchWordManagement',
    '头像管理': 'menu.avatarManagement',
    'Tabbar管理': 'menu.tabbarManagement',
    '手机区号管理': 'menu.mobileCodeManagement',
    '财务报表': 'menu.financialReport',
    '短剧报表': 'menu.videoReport',
    '金币充值订单列表': 'menu.coinRechargeOrderList',
    '版本更新': 'menu.versionUpdate',
    '版本管理': 'menu.versionManagement',
    '系统管理': 'menu.systemManagement',
    '用户查询': 'menu.userQuery',
    '用户新增': 'menu.userAdd',
    '用户修改': 'menu.userEdit',
    '用户删除': 'menu.userDelete',
    '用户导出': 'menu.userExport',
    '用户导入': 'menu.userImport',
    '重置密码': 'menu.resetPassword',
    '角色管理': 'menu.roleManagement',
    '角色查询': 'menu.roleQuery',
    '角色新增': 'menu.roleAdd',
    '角色修改': 'menu.roleEdit',
    '角色删除': 'menu.roleDelete',
    '脱敏权限': 'menu.maskPermission',
    '菜单管理': 'menu.menuManagement',
    '菜单查询': 'menu.menuQuery',
    '菜单新增': 'menu.menuAdd',
    '菜单修改': 'menu.menuEdit',
    '菜单删除': 'menu.menuDelete',
    '参数设置': 'menu.paramSettings',
    '参数查询': 'menu.paramQuery',
    '参数新增': 'menu.paramAdd',
    '参数修改': 'menu.paramEdit',
    '参数删除': 'menu.paramDelete',
    '参数导出': 'menu.paramExport',
    '通知公告': 'menu.noticeAnnouncement',
    '公告查询': 'menu.noticeQuery',
    '公告新增': 'menu.noticeAdd',
    '公告修改': 'menu.noticeEdit',
    '公告删除': 'menu.noticeDelete',
    '日志管理': 'menu.logManagement',
    '操作日志': 'menu.operationLog',
    '操作查询': 'menu.operationQuery',
    '操作删除': 'menu.operationDelete',
    '日志导出': 'menu.logExport',
    '登录日志': 'menu.loginLog',
    '登录查询': 'menu.loginQuery',
    '登录删除': 'menu.loginDelete',
    '账户解锁': 'menu.accountUnlock',
    '系统工具': 'menu.systemTools',
    '表单构建': 'menu.formBuilder',
    '代码生成': 'menu.codeGeneration',
    '生成查询': 'menu.generateQuery',
    '生成修改': 'menu.generateEdit',
    '生成删除': 'menu.generateDelete',
    '导入代码': 'menu.importCode',
    '预览代码': 'menu.previewCode',
    '生成代码': 'menu.generateCode',
    '系统接口': 'menu.systemInterface',
    '数据库文档': 'menu.databaseDoc',
    '系统监控': 'menu.systemMonitor',
    '数据监控': 'menu.dataMonitor',
    '服务监控': 'menu.serviceMonitor',
    '缓存监控': 'menu.cacheMonitor',
    '缓存列表': 'menu.cacheList'
  }
  
  // 如果 title 是国际化键值（以 route. 开头），直接使用 i18nRender
  if (title && title.startsWith && title.startsWith('route.')) {
    return i18nRender && i18nRender(title) || title
  }
  
  // 如果 title 在映射表中，使用映射的国际化键值
  const i18nKey = menuLabelMap[title]
  if (i18nKey && i18nRender) {
    return i18nRender(i18nKey) || title
  }
  
  // 否则直接返回原始标题
  return i18nRender && i18nRender(title) || title
}

const renderTitle = (h, title, i18nRender) => {
  return <span>{ getMenuLabel(title, i18nRender) }</span>
}

const RouteMenu = {
  name: 'RouteMenu',
  props: RouteMenuProps,
  data () {
    return {
      openKeys: [],
      selectedKeys: [],
      cachedOpenKeys: [],
      cachedSelectedKeys: []
    }
  },
  render (h) {
    const { mode, theme, menus, i18nRender } = this
    const handleOpenChange = (openKeys) => {
      // 在水平模式下时，不再执行后续
      if (mode === 'horizontal') {
        this.openKeys = openKeys
        return
      }
      const latestOpenKey = openKeys.find(key => !this.openKeys.includes(key))
      if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    }

    const dynamicProps = {
      props: {
        mode,
        theme,
        openKeys: this.openKeys,
        selectedKeys: this.selectedKeys
      },
      on: {
        select: menu => {
          this.$emit('select', menu)
          if (!httpReg.test(menu.key)) {
            this.selectedKeys = menu.selectedKeys
          }
        },
        openChange: handleOpenChange
      }
    }

    const menuItems = menus.map(item => {
      if (item.hidden) {
        return null
      }
      return renderMenu(h, item, i18nRender)
    })
    return <Menu {...dynamicProps}>{menuItems}</Menu>
  },
  methods: {
    updateMenu () {
      const names = this.$route.meta.names
      const { hidden } = this.$route.meta
      if (names.length >= 5 && hidden) {
        names.pop()
      }
      this.selectedKeys = [names[names.length - 1]]
      const openKeys = []
      if (this.mode === 'inline') {
        names.forEach(item => {
          item && openKeys.push(item)
        })
      }

      this.collapsed ? (this.cachedOpenKeys = openKeys) : (this.openKeys = openKeys)
    }
  },
  computed: {
    rootSubmenuKeys: vm => {
      const keys = []
      vm.menus.forEach(item => keys.push(item.name))
      return keys
    }
  },
  created () {
    this.$watch('$route', () => {
      this.updateMenu()
    })
    this.$watch('collapsed', val => {
      if (val) {
        this.cachedOpenKeys = this.openKeys.concat()
        this.openKeys = []
      } else {
        this.openKeys = this.cachedOpenKeys
      }
    })
  },
  mounted () {
    this.updateMenu()
  }
}

export default RouteMenu
